<template>
    <div class="bordas acoes-content">
        <button type="button"
                class="btn btn-sm btn-acoes"
                :class="item == tipoLeitoFiltradoStatus ? 'btn-secondary' : 'btn-outline-secondary'" 
                v-for="(item, index) in retorno"
                :key="index" 
                @click="filtra(item)"
                >

                {{item}}
        </button>
    </div>
</template>

<script>
export default {
     computed: {
        listagemMapaTipoLeito () {
            return this.$store.getters['tipoleito/getMapaTipoLeito']
        },
        retorno () {
            let resultado = []

            this.listagemMapaTipoLeito.forEach((i, index) => {
                i.conteudo.forEach((item) => {
                    resultado.push(item.nomeTipoClinico)
                })
            })

            return resultado.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
        },
        tipoLeitoFiltradoStatus () {
            return this.$store.getters['tipoleito/getTipoLeitoFiltradoStatus']
        }
    },
    methods: {
        filtra (item) {
            this.tipoLeitoFiltradoStatus == null ?
                this.$store.commit('tipoleito/setTipoLeitoFiltradoStatus', item) :
                this.$store.commit('tipoleito/setTipoLeitoFiltradoStatus', null)
        }
    }
}
</script>

<style>
    .acoes-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }

    .btn-acoes {
        margin: 6px;
        min-width: 125px;
    }

    @media (min-width: 1154px) {

        .acoes-content {
            flex-direction: column;
        }

        .btn-acoes {
            margin: 0 0 10px 0;
        }
    }
</style>

